import { Component, OnInit, Input} from "@angular/core";
import { DatePipe } from '@angular/common';
import { Router, NavigationStart } from '@angular/router';
//import { GridOptions, ColDef, AllModules } from '@ag-grid-enterprise/all-modules';
import { GridOptions, ColDef, GridApi } from "ag-grid-community";

import { Observable, EMPTY } from 'rxjs';
import { filter, map } from "rxjs/operators";

import { dateComparator } from "../../../common/components/data-table/comparators/data-table.comparators";
import { RouterLinkRendererComponent } from "../../../common/components/ag-grid/router-link-renderer.component";

import { GridFormatterService } from '../../../common/services/grid-formatter.service';
import { PaymentService } from "../../../payments/services/payment.service";
import { AuthService } from "../../../services/auth.service";
import { LunaClaimValues } from "../../../models/user-identity.model";
import { ApplicationPayment, PaymentSearchCriteria, PaymentStatus, PaymentType, PaymentRecordAdjustmentRequest, PaymentRecordAdjustment, PaymentRecordAdjustmentRequestSearchSpec, AdjustmentRequestStatus } from "../../../payments/models/paymentItem.model";
import { TabComponent } from "../../../common/components/tabs/tab.component";


@Component({
    selector: "pending-payments-widget",
    templateUrl: "./pending-payments-widget.component.html",
    standalone: false
})
export class PendingPaymentsWidgetComponent implements OnInit {
    @Input() widgetTitle: string;


    adjustmentData: Observable<PaymentRecordAdjustment[]>;
    data: Observable<ApplicationPayment[]>
	gridOptions: GridOptions;
	gridApi?: GridApi;
    adjustmentGridOptions: GridOptions;
	adjustmentGridApi?: GridApi;
    get showPendingAdjustments(): boolean {
        if (this.auth == null || this.auth.User == null) return false;
        return this.auth.User.systemPermissions.find(p => p == LunaClaimValues.ApprovePaymentAdjustments) != null;
    }

    constructor(
        public readonly paymentSvc: PaymentService,
        public datePipe: DatePipe,
        private formatterService: GridFormatterService,
        private router: Router,
        private auth: AuthService
	) { }

    ngOnInit() {
		const criteria = new PaymentSearchCriteria("", "", [PaymentStatus.Pending, PaymentStatus.Partial, PaymentStatus.Overdue], []);

        this.gridOptions = {
            columnDefs: this.createColumnDefinitions(),
            defaultColDef: { filter: true, sortable: true } as ColDef,
            enableBrowserTooltips: false,
            tooltipTrigger: 'focus',
			onGridReady: (params) => {
				this.gridApi = params.api;
				this.gridApi.sizeColumnsToFit();
            },
            suppressHorizontalScroll: true,
            pagination: true,
            paginationAutoPageSize: true,
            headerHeight: 50,
        } as GridOptions;
        this.adjustmentGridOptions = this.formatterService.BuildDefaultGridOptionsWithColumns(this.createAdjustmentColumns(), false, true, true, false);
        this.adjustmentGridOptions.headerHeight = 50;
		this.adjustmentGridOptions.groupDisplayType = "groupRows";
		this.adjustmentGridOptions.onGridReady = (params) => { this.adjustmentGridApi = params.api; };
        this.data = this.paymentSvc.search(criteria).pipe(); 

        this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.data = EMPTY;
        });
    }

    private createAdjustmentColumns(): ColDef[] {
        return [
            {
                headerClass: "wrapped",
                headerName: "Request #",
                field: "requestId",
                rowGroup: true,
                showRowGroup: true,
                maxWidth: 125,
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    openInNewWindow: false,
                    textField: "requestId",
                    url: (data: PaymentRecordAdjustment) => {
                        return `/payment/approve-payment-adjustment/${data.requestId}`;
                    }
                }
            },
            {
                headerClass: "wrapped",
                headerName: "From Application Number",
                field: "fromApplicationNumber",
                tooltipField: "fromApplicationNumber",
                maxWidth: 135
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "To Application Number",
                field: "toApplicationNumber",
                tooltipField: "toApplicationNumber",
                maxWidth: 135
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "From Payment",
                field: "fromApplicationPaymentId",
                tooltipField: "fromApplicationPaymentId",
                maxWidth: 125
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "From Fee",
                field: "fromPaymentDescription",
                tooltipField: "fromPaymentDescription"
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "To Fee",
                field: "toPaymentDescription",
                tooltipField: "toPaymentDescription"
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "To Payment",
                field: "toApplicationPaymentId",
                tooltipField: "toApplicationPaymentId",
                minWidth: 125,
                maxWidth: 135
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "Payment Instrument",
                field: "instrumentToken",
                tooltipField: "instrumentToken"
            } as ColDef,
            {
                headerClass: "wrapped",
                headerName: "Amount",
                field: "amountApplied",
                valueFormatter: this.formatterService.formatCurrency("amountApplied"),
                tooltipValueGetter: this.formatterService.formatCurrency("amountApplied"),
                maxWidth: 125,
                minWidth: 115,
            } as ColDef
        ];
    }

    public createColumnDefinitions() {
        let colDefs = [
            {
                headerClass: "wrapped",
                headerName: "Application #",
                headerTooltip: "Application #",
                field: "applicationNumber",
                tooltipField: "applicationNumber"
            },
            {
                headerClass: "wrapped",
                headerName: "Payment #",
                headerTooltip: "Payment #",
                field: "id",
                tooltipField: "id",
                cellRenderer: RouterLinkRendererComponent,
                cellRendererParams: {
                    textField: "id",
                    function: (data) => {
                        return `/common/process-payments/${data.organizationId}`
                    }
                }
            },
            {
                headerClass: "wrapped",
                headerName: "Organization",
                headerTooltip: "Organization",
                field: "organization",
                tooltipField: "organization"
            },
            {
                headerClass: "wrapped",
                headerName: "Application Type",
                headerTooltip: "Application Type",
                field: "applicationType",
                tooltipField: "applicationType"
            },
            {
                headerClass: "wrapped",
                headerName: "Application Date",
                headerTooltip: "Application Date",
                field: "applicationDate",
                tooltipValueGetter: this.formatterService.formatDate("applicationDate"),
                valueGetter: this.formatterService.formatDate("applicationDate"),
                comparator: dateComparator,
            }
        ] as ColDef[];
        this.formatterService.applyFilterKeyboardHintTooltips(colDefs);
        return colDefs;
    }

    onTabClicked(tab: TabComponent): void {
        if (tab.title === "Pending Adjustments") {
            let spec: PaymentRecordAdjustmentRequestSearchSpec = {
                inStatuses: [ AdjustmentRequestStatus.Pending ]
            } as PaymentRecordAdjustmentRequestSearchSpec;
            this.adjustmentData = this.paymentSvc.searchAdjustmentRequests(spec).pipe(
                map((reqs: PaymentRecordAdjustmentRequest[]) => {
                    let result: PaymentRecordAdjustment[] = [];
                    reqs.forEach(r => {
                        r.paymentRecordAdjustments.forEach(p => { result.push(p); });
                    });
                    return result;
                })
            )
        }
    }

}
